<op-date-picker-control
  [required]="to.required"
  [disable]="to.disabled"
  [formControl]="formControl"
  [formlyAttributes]="field"
>
</op-date-picker-control>